import { render } from "./BlockViewer.vue?vue&type=template&id=31717a97&scoped=true"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"

import "./BlockViewer.vue?vue&type=style&index=0&id=31717a97&scoped=true&lang=scss"

import exportComponent from "D:\\Trabalho\\Projetos\\Sistemas\\Front\\app-base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31717a97"]])

export default __exports__